/**
 * navItems.ts — the portal panel roadmap as nav model.
 *
 * Health, Leads, Conversations, Config, Numbers and Products are all live.
 * Numbers is `#numbers` (Stories N1/N2); Products is its own sidebar entry at
 * `#numbers/products` (Stories N3-N5), rendered by `NumbersPanel`.
 */

export interface NavItem {
  /** Stable id, used as the i18n key suffix (nav.<id>) and test selector. */
  id: 'health' | 'leads' | 'conversations' | 'config' | 'numbers' | 'products';
  /** Link target when it differs from `#<id>` (Products lives under `#numbers/products`). */
  href?: string;
  /** Live (navigable) vs. a disabled roadmap stub. */
  enabled: boolean;
}

export const NAV_ITEMS: readonly NavItem[] = [
  { id: 'health', enabled: true },
  { id: 'leads', enabled: true },
  { id: 'conversations', enabled: true },
  { id: 'config', enabled: true },
  { id: 'numbers', enabled: true },
  { id: 'products', enabled: true, href: '#numbers/products' },
];
